export default __webpack_public_path__ + "static/media/lost.3f32075c.svg";